import React from 'react'

export const TemplateBlockTwentyThree = ({ templateBlockClick, activeBlock }) => {
  return (
    <div className='flex flex-col w-full text-center'>

      <div className={`w-full p-4 bg-gray-200 rounded-lg flex flex-col gap-4 min-h-[270px] ${activeBlock === 23 ? "border-red-500 border-2" : ""}`}
        onClick={() => templateBlockClick(23,5)}
      >
        <div className="w-full flex justify-evenly gap-4 h-full">
          <div className="h-full w-1/3  border-2 border-blue-500"></div>
          <div className="h-full w-1/3  border-2 border-blue-500"></div>
          <div className="h-full w-1/3  border-2 border-blue-500"></div>
        </div>
        <div className="w-full flex justify-evenly gap-4 h-full">
          <div className="h-full w-1/3  border-2 border-blue-500"></div>
          <div className="h-full w-2/3  border-2 border-blue-500"></div>
        </div>
      </div>
      <p className='font-bold'>Type 24</p>
    </div>
  )
}
